import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

// Client Care Hub — the signed-in client's own paid virtual assessments.
// Unfinished purchases resume through their existing purchase token (no new charge).
export const PaidAssessments = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/assessment-purchases/my").then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, []);
  if (!items || items.length === 0) return null;
  return (
    <div className="mt-10" data-testid="client-paid-assessments">
      <div className="kcis-overline mb-4">Your paid virtual assessments</div>
      <div className="space-y-3">
        {items.map((p) => {
          const done = !!p.assessment_completed_at || p.status === "assessment_completed";
          return (
            <div key={p.id} className="kcis-card p-5 flex flex-wrap items-center justify-between gap-3" data-testid={`paid-assessment-${p.id}`}>
              <div>
                <div className="font-medium text-slate-900">{p.label} {p.amount_display ? `· ${p.amount_display}` : ""}</div>
                <div className="text-xs text-slate-500 mt-1">
                  Purchased {p.purchase_date ? new Date(p.purchase_date).toLocaleDateString() : ""} · {done ? "Submitted — findings are delivered by the KISSED team" : "Not finished yet"}
                </div>
              </div>
              {!done && (
                <Link to={`/clinical-assessment?tier=${encodeURIComponent(p.assessment_tier)}&ref=${encodeURIComponent(p.purchase_token)}`}
                  className="rounded-full bg-purple-900 text-white text-sm px-4 py-2" data-testid={`paid-assessment-resume-${p.id}`}>
                  Resume assessment
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
